var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: { title: "详情", visible: _vm.dialogFormVisible },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
            close: _vm.close,
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  attrs: {
                    model: _vm.form,
                    "label-width": "120px",
                    disabled: "",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "变动方式：", prop: "customerEmpType" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form.customerEmpType,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "customerEmpType", $$v)
                          },
                          expression: "form.customerEmpType",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isMinAdmin
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "提交人：", prop: "creatorId" } },
                        [
                          _c("el-input", {
                            attrs: { value: _vm.creatorDisplayName },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "原因：", prop: "reason" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.form.reason,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "reason", $$v)
                          },
                          expression: "form.reason",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单类型：", prop: "orderType" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.orderTypeText,
                          callback: function ($$v) {
                            _vm.orderTypeText = $$v
                          },
                          expression: "orderTypeText",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "面额：", prop: "integral" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.form.integral,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "integral", $$v)
                          },
                          expression: "form.integral",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "发放小程序：", prop: "appName" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.form.appName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "appName", $$v)
                          },
                          expression: "form.appName",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "项目编号：", prop: "projectNumber" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入项目编号" },
                        model: {
                          value: _vm.form.projectNumber,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "projectNumber", $$v)
                          },
                          expression: "form.projectNumber",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isMinAdmin
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "申请编号：",
                            prop: "applicationNumber",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入申请编号" },
                            model: {
                              value: _vm.form.applicationNumber,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "applicationNumber", $$v)
                              },
                              expression: "form.applicationNumber",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "发放公司：", prop: "companyId" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "发放公司名称" },
                        model: {
                          value: _vm.companyDisplayName,
                          callback: function ($$v) {
                            _vm.companyDisplayName = $$v
                          },
                          expression: "companyDisplayName",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "销售总价：", prop: "salesPrice" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "销售总价" },
                        model: {
                          value: _vm.form.salesPrice,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "salesPrice", $$v)
                          },
                          expression: "form.salesPrice",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.form.sendTypeName
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { label: "发卡类型：", prop: "sendTypeName" },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.form.sendTypeName,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "sendTypeName", $$v)
                              },
                              expression: "form.sendTypeName",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.form.couponPackageId
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "优惠券包：",
                            prop: "couponPackageId",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.couponPackageInfo,
                              callback: function ($$v) {
                                _vm.couponPackageInfo = $$v
                              },
                              expression: "couponPackageInfo",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.form.orderType === 1 && _vm.form.fuCardId
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "福卡信息：", prop: "fuCardInfo" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.cardInfo,
                              callback: function ($$v) {
                                _vm.cardInfo = $$v
                              },
                              expression: "cardInfo",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.form.orderType === 2 && _vm.form.fuPackageId
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "权益卡包：", prop: "packageInfo" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.form.fuPackageName,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "fuPackageName", $$v)
                              },
                              expression: "form.fuPackageName",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.form.orderType === 2 && _vm.form.fuConfig
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "卡片分配：",
                            prop: "cardAllocation",
                          },
                        },
                        [
                          _c(
                            "el-table",
                            {
                              attrs: {
                                data: _vm.cardAllocations,
                                size: "mini",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: { prop: "cardName", label: "卡片名称" },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "beans",
                                  label: "分配福豆",
                                  formatter: _vm.formatYuanColumn,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "福卡有效期：", prop: "validTime" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.validTimeRange,
                          callback: function ($$v) {
                            _vm.validTimeRange = $$v
                          },
                          expression: "validTimeRange",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "创建时间：", prop: "createTime" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.form.createTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "createTime", $$v)
                          },
                          expression: "form.createTime",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "发放时间：", prop: "exeTime" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.form.exeTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "exeTime", $$v)
                          },
                          expression: "form.exeTime",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.miniProgramCustomer
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "内部备注：", prop: "remark" } },
                        [
                          _c("el-input", {
                            attrs: { type: "textarea" },
                            model: {
                              value: _vm.form.remark,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "remark", $$v)
                              },
                              expression: "form.remark",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "备注：", prop: "innerRemark" } },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea" },
                        model: {
                          value: _vm.form.innerRemark,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "innerRemark", $$v)
                          },
                          expression: "form.innerRemark",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "涉及员工" } },
                    [
                      _c(
                        "el-table",
                        { attrs: { data: _vm.form.customerEmpList.list } },
                        [
                          _c("el-table-column", {
                            attrs: { prop: "empNo", label: "工号" },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { prop: "empName", label: "姓名" },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { prop: "phone", label: "手机号" },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { prop: "wechat", label: "微信" },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { prop: "dept", label: "部门" },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { prop: "title", label: "职位" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.form.customerEmpList
                ? _c("el-pagination", {
                    attrs: {
                      "page-sizes": [15, 30, 45, 60],
                      "page-size": _vm.pageFrom.limit,
                      "current-page": _vm.pageFrom.page,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.form.customerEmpList.total,
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.pageChange,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isMinAdmin
                ? _c(
                    "el-form",
                    {
                      staticClass: "audit-log-form",
                      attrs: { "label-width": "120px", disabled: "" },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "审核日志：" } },
                        [
                          _vm.auditLogList.length
                            ? _c(
                                "el-table",
                                {
                                  attrs: {
                                    data: _vm.auditLogList,
                                    size: "mini",
                                    border: "",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "auditorName",
                                      label: "审核人",
                                      "min-width": "100",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "auditResult",
                                      label: "审核结果",
                                      "min-width": "120",
                                      formatter: _vm.formatAuditResult,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "rejectReason",
                                      label: "驳回原因",
                                      "min-width": "160",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    scope.row.rejectReason ||
                                                      "无"
                                                  ) +
                                                  "\n              "
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2164086710
                                    ),
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "operationTime",
                                      label: "操作时间",
                                      "min-width": "180",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _c("span", { staticClass: "audit-log-empty" }, [
                                _vm._v("无"),
                              ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  staticStyle: { "margin-top": "20px", "text-align": "center" },
                },
                [
                  _c("el-button", { on: { click: _vm.close } }, [
                    _vm._v("关闭"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }